import type { FunctionComponent } from 'react';
import { Navigate, Outlet } from 'react-router';

import type { PrivateRouteProps } from './PrivateRoute.props';
import { useAuth } from '../../components/management/NewAuthProvider';
import { useApplication } from 'ApplicationContext.tsx';

const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({ to = '/', element, shouldAllow }) => {
  const { user, isImpersonating, isAdmin } = useAuth();
  const { app } = useApplication();

  if (
    shouldAllow?.({
      groups: user?.groups ?? [],
      isImpersonating,
      isAdmin,
      app,
    })
  ) {
    return element ?? <Outlet />;
  }

  return <Navigate to={to} replace />;
};

export default PrivateRoute;
